import React from 'react';
import PropTypes from 'prop-types';
import FieldGroup from '../../common/forms/FieldGroup'
import SubmitButton from '../../common/forms/SubmitButton'
import SubmitSpinner from '../../common/Spinners/SubmitSpinner'
import SuccessCheckMessage from '../../common/SuccessCheckMessage'
import LinkActionButton from '../../common/Buttons/LinkActionButton'
import { Row, Col, Form} from 'react-bootstrap'


const ResetPassword = ({
  validationstate,
  newPassword,
  confirmedPassword,
  submitting,
  submitted,
  updatePassword,
  newPasswordChange,
  confirmedPasswordChange,
  goToLogin
}) => (
  <div >
    <h1>New Password</h1>
    <Row>
      <Col xs={12} sm={12} md={6} lg={6}>
        <form noValidate onSubmit={(event) => {
          event.preventDefault()
          updatePassword()
        }}>
          <FieldGroup
            required
            type={'password'}
            disabled={submitting}
            value={newPassword}
            handleChange={newPasswordChange}
            placeholder='Password'
            label='New password'
            message={validationstate.newPassword.message}
            isInvalid={validationstate.newPassword.isInvalid} />
          <FieldGroup
            required
            type={'password'}
            disabled={submitting}
            value={confirmedPassword}
            handleChange={confirmedPasswordChange}
            placeholder='Password'
            label='Confirm password'
            message={validationstate.confirmedPassword.message}
            isInvalid={validationstate.confirmedPassword.isInvalid} />
          <Form.Group>
            <SubmitButton
              buttonText={'Submit'}
              isValid={validationstate.formIsValid && !submitted}
              isSubmitting={submitting} />
            {submitting && <SubmitSpinner />}
            {submitted && <SuccessCheckMessage message={'Your password has been reset.'} />}
            {submitted && <LinkActionButton buttonText={'Go back to login.'} onClick={goToLogin} />}
          </Form.Group>
        </form>
      </Col>
    </Row>
  </div>
  )

ResetPassword.propTypes = {
  validationstate: PropTypes.object.isRequired,
  newPassword: PropTypes.string.isRequired,
  confirmedPassword: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitted: PropTypes.bool.isRequired,
  updatePassword: PropTypes.func.isRequired,
  newPasswordChange: PropTypes.func.isRequired,
  confirmedPasswordChange: PropTypes.func.isRequired,
  goToLogin: PropTypes.func.isRequired
}

export default ResetPassword
